import { BadgeCheck, Receipt, Clock, HeartHandshake } from "lucide-react";
import { PILLARS } from "../constants";
import { Reveal } from "./Reveal";

const ICONS = { BadgeCheck, Receipt, Clock, HeartHandshake };

const Solution = () => (
    <section
        className="py-16 sm:py-24 lg:py-32 relative overflow-hidden"
        style={{ background: "linear-gradient(180deg, #F8FAFC 0%, #F4F8FF 100%)" }}
        data-testid="solution-section"
    >
        <div
            className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 w-[50rem] h-[24rem] rounded-full opacity-60"
            style={{ background: "radial-gradient(ellipse, rgba(11,92,245,0.08), transparent 65%)" }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <div className="max-w-3xl">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B5CF5] mb-4">The Sevano way</p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2
                        className="font-display font-medium text-slate-900 text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.1]"
                        data-testid="solution-section-title"
                    >
                        Household help, <span className="italic text-[#0B5CF5]">made simpler.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Sevano is an on-demand household-help platform — request help when you need it, for as
                        long as you need it. Here's what we're building toward, presented honestly as planned
                        features, not promises of today.
                    </p>
                </Reveal>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {PILLARS.map((p, i) => {
                    const Icon = ICONS[p.icon];
                    return (
                        <Reveal key={p.title} delay={i * 0.1}>
                            <div className="group h-full rounded-3xl bg-white border border-slate-100 p-6 sm:p-7 shadow-[0_10px_40px_-16px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-18px_rgba(11,92,245,0.20)]">
                                <div className="flex items-start justify-between mb-5">
                                    <div className="w-12 h-12 rounded-2xl bg-[#F4F8FF] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#0B5CF5]">
                                        <Icon size={22} className="text-[#0B5CF5] transition-colors duration-300 group-hover:text-white" />
                                    </div>
                                    <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#0B5CF5] bg-[#EBF2FF] rounded-full px-2.5 py-1">
                                        {p.status}
                                    </span>
                                </div>
                                <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2 tracking-tight">{p.title}</h3>
                                <p className="text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Solution;
